import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Hero from './components/Hero';
import ProductsGrid from './components/ProductsGrid';
import WorkshopServices from './components/WorkshopServices';
import Logistics from './components/Logistics';
import AboutHistory from './components/AboutHistory';
import MissionVision from './components/MissionVision';
import Clients from './components/Clients';
import ContactSection from './components/ContactSection';

export default function Home() {
  return (
    <>
      <Navbar />
      {/* Spacer for fixed header (mobile: top bar only, desktop: top bar + nav) */}
      <div className="h-14 md:h-28"></div>
      <main>
        <Hero />
        <ProductsGrid />
        <WorkshopServices />
        <Logistics />
        <AboutHistory />
        <MissionVision />
        <Clients />
        <ContactSection />
      </main>
      <Footer />
    </>
  );
}